// extracted by mini-css-extract-plugin
module.exports = {"consignment":"Consignment_consignment__3Hrrt","seller-action-container":"Consignment_seller-action-container__3j9zO"};